export * from './addRectangle'
export * from './getRectangle'
export * from './updateRectangle'
export * from './removeRectangle'
